import { Routes } from '@angular/router';
import { ChatPageComponent } from './pages/chat/chat-page';
import { RagDocumentsComponent } from './pages/rag/documents/rag-documents.component';
import { SettingsPageComponent } from './pages/settings/settings-page.component';
import { authGuard } from './core/guards/auth.guard';
import { AuthCallbackComponent } from './pages/auth/auth-callback.component';
import { LoginPageComponent } from './pages/auth/login-page.component';
import { BillHistoryComponent } from './features/bill-splitter/bill-history.component';

export const routes: Routes = [
  { path: 'auth/login', component: LoginPageComponent },
  { path: 'auth/callback', component: AuthCallbackComponent },
  { path: '', pathMatch: 'full', redirectTo: 'chat' },
  { path: 'chat', component: ChatPageComponent, canActivate: [authGuard] },
  { path: 'chat/:threadId', component: ChatPageComponent, canActivate: [authGuard] },
  { path: 'settings', component: SettingsPageComponent, canActivate: [authGuard] },
  { path: 'documents', component: RagDocumentsComponent, canActivate: [authGuard] },
  { path: 'bill-splitter', loadChildren: () => import('./features/bill-splitter/bill-splitter.routes').then((m) => m.BILL_SPLITTER_ROUTES), canActivate: [authGuard] },
  { path: 'bills', component: BillHistoryComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: 'chat' },
];
